import { HttpContextToken } from "@angular/common/http";

/**
 * Marks a request whose failure the caller handles itself: a 403 on it must
 * NOT trigger HttpConfigInterceptor's redirect to the dashboard, nor its
 * generic error toast.
 *
 * Use for optional reads that a page can live without. Example: the
 * workspace's language list — access-code guests get a 403 on
 * `/shotlist/language/:videoId`, and the global redirect was bouncing them
 * out of the workspace entirely over a picker that simply hides when empty.
 *
 * A context token rather than a header because the API's CORS allowlist
 * would reject an unknown header, and this flag is client-only anyway.
 */
export const OPTIONAL_REQUEST = new HttpContextToken<boolean>(() => false);
